import { GetServerSideProps } from 'next'
import Head from 'next/head'
import { metadataModels } from '@/app/utils/metadata'
import { MachineProps } from '@/app/interface/pages'
import Machine from '@/app/components/Machine'
import { models } from '@/app/utils/models'

export default function Models({ title, description, model }: MachineProps) {
    const modelData = models[model]

    return (
        <>
            <Head>
                <title>{title}</title>
                <meta name="description" content={description} />
                <link rel="preload" as="image" href={`https://gabcomercio.azureedge.net/azul-agro/desktop/machines/${modelData.machine}/${model}/product.webp`} media="(min-width: 1140px)" />
                <link rel="preload" as="image" href={`https://gabcomercio.azureedge.net/azul-agro/tablet/machines/${modelData.machine}/${model}/product.webp`} media="(min-width: 540px) and (max-width: 1139px)" />
                <link rel="preload" as="image" href={`https://gabcomercio.azureedge.net/azul-agro/mobile/machines/${modelData.machine}/${model}/product.webp`} media="(max-width: 539px)" />
            </Head>
            <Machine model={model} modelData={modelData} />
        </>
    )
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    const { pageName } = context.params as { pageName: string }

    // Extrai a parte relevante do pageName, ignorando parâmetros adicionais
    const cleanPageName = pageName.split('?')[0]

    // Verifica a igualdade estrita com os modelos disponíveis
    const model = Object.keys(metadataModels).find(key => cleanPageName === key)

    if (!model) {
        return {
            notFound: true,
        }
    }

    const metadata = metadataModels[model]

    return {
        props: {
            title: metadata.title,
            description: metadata.description,
            model
        }
    }
}
